import { Ingredient } from "../components/IngredientCell";

export const Ingredients: {[index: string]: Ingredient[]} = {
  "combatant": [
    {
      name: "Vex Milk",
      description: "An ingredient that adds a bit of radiolarian liquid to anything it touches.",
      source: "Killing Vex combatants",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/164be4c9058691eedad58cf950c4f8d0.jpg",
    },
    {
      name: "Ether Cane",
      description: "An ingredient that adds an ethereal sweetness to anything it touches.",
      source: "Killing Fallen combatants",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/d22b8aca25c15b82bf18c543f7c2045a.jpg",
    },
    {
      name: "Cabal Oil",
      description: "An ingredient that toughens and thickens up anything it touches.",
      source: "Killing Cabal combatants",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/862dbd96dfe363621d95a83ce9ada1cb.jpg",
    },
    {
      name: "Chitin Powder",
      description: "An ingredient that adds a bit of spice to anything it touches.",
      source: "Killing Hive combatants",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/8a52e59ade90e9de1bfe75187a841a54.jpg",
    },
    {
      name: "Taken Butter",
      description: "An ingredient that adds an echoing deliciousness to anything it touches.",
      source: "Killing Taken combatants",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/cc2b721eeba1ff93b7d16e60034d696f.jpg",
    },
    {
      name: "Dark Ether Cane",
      description: "An ingredient that adds a darkly sweet aroma to anything it touches. ",
      source: "Killing Scorn combatants",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/164be4c9058691eedad58cf950c4f8d0.jpg",
    },
  ],
  "killstyle": [
    {
      name: "Delicious Explosion",
      description: "Sudden and violent. And also tasty.",
      source: "Explosive kills of any kind",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/9484a95d62bf16f28d92d95489da7092.jpg",
    },
    {
      name: "Sharp Flavor",
      description: "A taste that will cut right through your taste buds.",
      source: "Sword kills",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/b1fa823b599fb1fd3d3264d9e2fc1272.jpg",
    },
    {
      name: "Impossible Heat",
      description: "Hotter than a Golden Gun on the surface of the sun.",
      source: "Solar kills with class abilities or elemental weapons",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/587b74ebe33a31c3d67316daaa1c6775.jpg",
    },
    {
      name: "Electric Flavor",
      description: "It courses through everything we touch… and taste.",
      source: "Arc kills with class abilities or elemental weapons",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/e18671b8fd0b28f4f2e763c2d0b89952.jpg",
    },
    {
      name: "Null Taste",
      description: "Between the light and the dark lies deliciousness.",
      source: "Void kills with class abilities or elemental weapons",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/332119f73f560572aa7fdfd245cb90e5.jpg",
    },
    {
      name: "Flash of Inspiration",
      description: "Just the right thing at just the right time.",
      source: "Generating Orbs of Power",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/8725ad767c3b9c3bf0f170007b492034.jpg",
    },
    {
      name: "Personal Touch",
      description: "A delicious taste achieved by getting up close and personal.",
      source: "Melee kills",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/06954590a246b60beccfeaf2088b7cc4.jpg",
    },
    {
      name: "Perfect Taste",
      description: "This flavor will hit the bull's-eye every time.",
      source: "Precision kills",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/13326575be1d6af65b1823972adbd082.jpg",
    },
    {
      name: "Bullet Spray",
      description: "The more, the merrier.",
      source: "Kills with automatic weapons (auto rifles, SMGs & machine guns)",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/8f362597f7a89d00ab764a62d6af1a2a.jpg",
    },
    {
      name: "Finishing Touch",
      description: "An ingredient that adds the necessary finishing touches to your recipe.",
      source: "Kills with finishers",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/4bd3835e4bd4e9cefc59cf7586323e4d.jpg",
    },
    {
      name: "Balanced Flavors",
      description: "An ingredient that brings all the flavors in your recipe together.",
      source: "Kills with bows, sniper rifles and scout rifles",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/653ce8c5ead9153fc6b95e1bfdafee3f.jpg",
    },
    {
      name: "Pinch of Light",
      description: "An ingredient that adds a touch of the Traveler's Light to your recipe.",
      source: "Collecting Orbs of Power",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/a5da475095401f2da5e74e8f50d78cbe.jpg",
    },
    {
      name: "Multifaceted Flavors",
      description: "An ingredient that brings a depth of flavor to your recipe.",
      source: "Multikills",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/7647f90014f018494837f536ec496f17.jpg",
    },
    {
      name: "Superb Texture",
      description: "An ingredient that gives your recipe a pleasing texture.",
      source: "Super kills",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/7da5c69667c72928f1c452bbdb871d52.jpg",
    },
    {
      name: "Dark Frosting",
      description: "An ingredient that adds a decadently deep, rich flavor.",
      source: "Defeating targets with Stasis damage",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/5a25fb6a8dde8514da3258969d926bb0.jpg",
    }
  ],
  "essence": [
    {
      name: "Essence of Dawning",
      description: "An ingredient needed for all recipies.",
      source: "Activity completions and bounties",
      imageUrl: "https://www.bungie.net/common/destiny2_content/icons/f9aa6dcb0e29d7536e2a2f34c6f604cd.jpg",
    },
  ]
}